import api from './api';
import axios, { AxiosResponse } from 'axios';
import { authService } from 'ui/services';

function getBaseURL() {
  if (process.env.NODE_ENV === 'development') {
    return process.env.NEXT_PUBLIC_BASEPATH_URL;
  }
  return process.env.NEXT_PUBLIC_BASE_URL;
}

const apiA = axios.create({
  baseURL: getBaseURL(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

function createAxios() {
  const axiosApi = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    timeout: 10000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  axiosApi.interceptors.request.use(
    async (config) => {
      if (!config.headers?.Authorization && config.url?.includes('saphybris-proxy/v1/saphybris')) {
        const res = await authService.getSystemAuth();
        config.headers.Authorization = `Bearer ${res.data?.token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosApi.interceptors.response.use(
    async (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (
        originalRequest?.url?.includes('saphybris-proxy/v1/saphybris') ||
        originalRequest?.method === 'post'
      ) {
        if (
          (error?.response?.status === 401 || error?.response?.status === 403) &&
          !originalRequest._retry
        ) {
          try {
            originalRequest._retry = true;
            //hit next js api to renew system_token cookie
            const res = await authService.getSystemAuth(true);
            originalRequest.headers['Authorization'] = `Bearer ${res.data?.token}`;
            return apiA(originalRequest);
          } catch (_) {
            return Promise.reject(error);
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosApi;
}

export const getContactUs = (): Promise<any> => {
  try {
    return api.get(`/saphybris-proxy/v1/saphybris/contact-us/enquiries`);
  } catch (error) {
    console.log(error);
  }
};

export const postImageTest = async (payload) => {
  const response: AxiosResponse = await createAxios()<{
    data;
  }>('/saphybris-proxy/v1/saphybris/contact-us/upload-doc', {
    method: 'POST',
    data: payload,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

export const submitContactUs = async (payload) => {
  try {
    return api.post('saphybris-proxy/v1/saphybris/contact-us', null, payload);
  } catch (error) {
    console.log(error);
  }
};

export const getMasterDataDsr = async () => {
  try {
    return api.get('/saphybris-proxy/v1/saphybris/contact-us/get-data-dsr');
  } catch (error) {
    console.log(error);
  }
};

export default {
  getContactUs,
  postImageTest,
  submitContactUs,
  getMasterDataDsr,
};
